import React, { useState, useEffect } from "react"
import Grid from "@material-ui/core/Grid"
import Layout from "../components/layout"
import axios from "axios"
import Loading from "./loading"
import Seo from "../components/seo"
import Button from '@material-ui/core/Button';
import PremiumServices from "../components/Sidebar/PremiumServices"
import {CoastalReportHeading, CoastalReportsFullPage} from "./coastalreports"

export const ShippingTitle = () => {
  const [url, setUrl] = useState(process.env.MET_SHIPPING)
  const [seaTempData, setSeaTempData] = useState([])
  const [error, setError] = useState(false)

  useEffect(() => {
    const fetchData = async () => {
      setError(false)
      try {
        const result = await axios(url)
        setSeaTempData(result.data.seatempToday)
      } catch (error) {
        setError(true)
        console.log(error)
      }
    }
    fetchData()
  }, [url])

  return (
    <>
    <h1>
        Shipping forecast <span className="shippingTemperature"><span>Current sea temperature</span> <span className="currentTemperatureValue">
          {seaTempData}
          </span></span>
        </h1>    
    </>
  )
}

export const ShippingMainPage = () => {
  const [url, setUrl] = useState(process.env.MET_SHIPPING)
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)

  useEffect(() => {
    const fetchData = async () => {
      setError(false)
      setLoading(true)
      try {
        const result = await axios(url)
        setData(result.data)
      } catch (error) {
        setError(true)
        console.log(error)
      }
      setLoading(false)
    }
    fetchData()
  }, [url])
  
  return (
    <>
    {error ? (
                <div>
                  <p style={{ color: "#bf0d0d" }}>
                    Sorry, the shipping forecast information is not available at
                    the moment. Please check back later.
                  </p>
                  <div style={{textAlign:"center"}}><Button className="resendButton" onClick={() => setUrl(process.env.MET_SHIPPING) }>Try again</Button></div>
                </div>
              ) : (
                <React.Fragment>
                  {loading ? (
                    <Loading />
                  ) : (
                    <React.Fragment>
                      <p style={{marginTop:"0"}}>
                        For the area bounded by latitude 50N, the French coast
                        between Cap de la Hague and Île de Bréhat and longitude
                        3W.
                      </p>

                      <p dangerouslySetInnerHTML={{ __html: data.Date }}></p>
                      <h2>General situation</h2>
                      <span
                        dangerouslySetInnerHTML={{ __html: data.General }}
                      ></span>
                      <h3>{data.Issued}</h3>
                      <p>
                        <strong>Wind: </strong>
                        <span
                          dangerouslySetInnerHTML={{
                            __html: data.winddescToday,
                          }}
                        ></span>
                      </p>
                      <p>
                        <strong>Sea state: </strong>
                        <span
                          dangerouslySetInnerHTML={{
                            __html: data.seastateToday,
                          }}
                        ></span>
                      </p>
                      <p>
                        <strong>Weather: </strong>
                        <span
                          dangerouslySetInnerHTML={{
                            __html: data.weatherToday,
                          }}
                        ></span>
                      </p>
                      <p>
                        <strong>Visibility: </strong>
                        <span
                          dangerouslySetInnerHTML={{
                            __html: data.visibilityToday,
                          }}
                        ></span>
                      </p>
                      <p>
                        <strong>Sea temperature: </strong>
                        <span
                          dangerouslySetInnerHTML={{
                            __html: data.seatempToday,
                          }}
                        ></span>
                      </p>
                      <h3>{data.forecastTimeTomorrow}</h3>
                      <p>
                        <strong>Wind: </strong>
                        <span
                          dangerouslySetInnerHTML={{
                            __html: data.winddescTomorrow,
                          }}
                        ></span>
                      </p>
                      <p>
                        <strong>Sea state: </strong>
                        <span
                          dangerouslySetInnerHTML={{
                            __html: data.seastateTomorrow,
                          }}
                        ></span>
                      </p>
                      <p>
                        <strong>Weather: </strong>
                        <span
                          dangerouslySetInnerHTML={{
                            __html: data.weatherTomorrow,
                          }}
                        ></span>
                      </p>
                      <p>
                        <strong>Visibility: </strong>
                        <span
                          dangerouslySetInnerHTML={{
                            __html: data.visibilityTomorrow,
                          }}
                        ></span>
                      </p>
                    </React.Fragment>
                  )}
                </React.Fragment>
              )}
    </>
  )
}

const Shipping = () => {
  
  return (
    <React.Fragment>
      <Layout>
      <Seo title="Channel Islands shipping forecast" description="The latest shipping forecast issued by the Jersey Meteorological Department for the Channel Islands area" />
      <div className="forecastAutoMargin">
        <Grid item xs={12} sm={12} md={8} lg={8} className="menuTitle" style={{paddingLeft:0}}>
                  <ShippingTitle/>               
      </Grid>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={8} lg={8}>
            <div className="Content">
              <ShippingMainPage/>
              <CoastalReportHeading/>
              <p />
              <CoastalReportsFullPage/>
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={4}>
              <PremiumServices />
            </Grid>
          </Grid>
        </div>
      </Layout>
    </React.Fragment>
  )
}
export default Shipping
